import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// @ts-ignore
const selectedBusiness: BusinessType = localStorage?.getItem("selectedBusiness")
  ? JSON.parse(localStorage?.getItem("selectedBusiness") || "")
  : "";
const initialState: BusienssSliceType = {
  businesses: [],
  business: selectedBusiness,
};

export const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setBusinesses: (
      state: BusienssSliceType,
      action: PayloadAction<EntityType[]>
    ) => {
      state.businesses = action.payload;
    },
    setBusiness: (
      state: BusienssSliceType,
      action: PayloadAction<BusinessType>
    ) => {
      state.business = action.payload;
    },
    resetBusinessState: (state: BusienssSliceType) => {
      state.business = null;
      state.businesses = [];
    },
  },
});

export const { setBusinesses, setBusiness, resetBusinessState } =
  businessSlice.actions;
export default businessSlice.reducer;
